import { matchType } from "../../../domain/base/base-type";

const StatusUpdateErrorCodes = [
  "not_found",
  "applications.same_status_selected",
  "applications.status_unchangeable",
  "applications.refund_required",
] as const;

export type StatusUpdateErrorCodeLiterals =
  (typeof StatusUpdateErrorCodes)[number];

export const toErrorMessage = (code: StatusUpdateErrorCodeLiterals) => {
  const message = matchType<StatusUpdateErrorCodeLiterals, string>(code, {
    not_found: "対象の申請が存在しない、または操作権限がありません。",
    "applications.same_status_selected":
      "変更元と同じステータスが選択されています。",
    "applications.status_unchangeable":
      "変更できないステータスが選択されています。",
    "applications.refund_required":
      "ステータス変更には返金処理が必要な申請です。",
  });
  return (
    message ||
    "予期せぬエラーが発生したため更新することができませんでした。時間をおいてから、再度お試しください。"
  );
};
